import React__default from 'react';
import { useAnalytics } from '@sravni/react-utils';

/**
 * React hook is a wrapper under useAnalytics hook
 * @returns pushAnalyticEvent callback to send GA events
 */
const useAnalyticEvents = () => {
    const { pushEvent } = useAnalytics();
    const pushAnalyticEvent = React__default.useCallback((event, options) => {
        let eventAction = options?.eventAction || '';
        let eventLabel = options?.eventLabel || '';
        let eventCategory = options?.eventCategory || '';
        const defaultEventProperties = {
            event: 'mainEvent',
            eventCategory: 'Меню',
        };
        // eslint-disable-next-line default-case
        switch (event) {
            case "login" /* EVENTS.LOGIN */:
                eventAction = 'Профиль';
                eventLabel = 'Войти';
                break;
            case "logout" /* EVENTS.LOGOUT */:
                eventAction = 'Профиль';
                eventLabel = 'Выйти';
                break;
            case "menuLinkClick" /* EVENTS.MENU_LINK_CLICK */:
                eventAction = 'Переход из меню';
                break;
            case "promoBannerClick" /* EVENTS.PROMO_BANNER_CLICK */:
                eventAction = 'Переход из меню|Кнопка партнера';
                break;
            case "promoLinkInView" /* EVENTS.PROMO_LINK_IN_VIEW */:
                eventAction = 'Показ кнопки партнера';
                break;
            case "topMenuShow" /* EVENTS.TOP_MENU_SHOW */:
            case "userMenuShow" /* EVENTS.USER_MENU_SHOW */:
                eventAction = 'Показ раздела';
                break;
            case "mobileBurgerClick" /* EVENTS.MOBILE_BURGER_CLICK */:
                eventAction = 'Бургер';
                break;
            case "regionDialogClick" /* EVENTS.REGION_DIALOG_CLICK */:
                eventAction = 'Выбор города';
                break;
            case "themeSwitcherClick" /* EVENTS.THEME_SWITCHER_CLICK */:
                eventAction = 'Активация|Переключение';
                eventCategory = 'Тема';
                break;
            case "themeDetectorChange" /* EVENTS.THEME_DETECTOR_CHANGE */:
                eventAction = 'Активация|Автоопределение';
                eventCategory = 'Тема';
                break;
            case "downloadApp" /* EVENTS.DOWNLOAD_APP */:
                eventCategory = 'Меню профиля';
                break;
            case "logoClick" /* EVENTS.LOGO_CLICK */:
                eventCategory = 'Прочее';
                eventAction = 'Лого|Сравни';
                break;
        }
        pushEvent({
            ...defaultEventProperties,
            eventAction,
            eventLabel,
            ...(eventCategory.length > 0 ? { eventCategory } : {}),
        });
    }, [pushEvent]);
    return { pushAnalyticEvent };
};

export { useAnalyticEvents };
//# sourceMappingURL=useAnalyticEvents.js.map
